import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

/* ── Desktop body (rendered inside the shell's centre column) ─────────────── */

export const DesktopBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const DropdownSlot = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 8px;
`;

/* Fixed 2:1 map box (Figma 804×406) — sized by width, so it never stretches to
 * fill the column height. */
export const MapSlot = styled.div`
  width: 100%;
  aspect-ratio: 2 / 1;
  min-height: 0;
`;

/* ── Mobile body (rendered inside the mobile shell, below the progress bar) ──
 * Centered text + generous vertical spacing, matching the Spark mobile design. */

export const MobileBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Heading = styled(Text)`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.1;
  text-align: center;
  background-image: ${CUST_GRADIENTS.headingGradient};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const Subtext = styled(Text)`
  margin-top: 40px;
  max-width: 320px;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  color: ${CUST.textMuted};
`;

export const MobileDropdownSlot = styled.div`
  margin-top: 48px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

/* 2:1 map — `align-self: stretch` overrides MobileBody's `align-items: center`
 * (which would otherwise shrink it to content width) so it spans the full body
 * width, with 32px vertical margins. */
export const MobileMapSlot = styled.div`
  align-self: stretch;
  margin: 32px 0;
  aspect-ratio: 2 / 1;
`;